<div class="c-modal c-modal--md">
	<div mat-dialog-content class="c-modal__dialog">
		<form name="vm.form" #mainForm="ngForm" class="c-form" novalidate>
			<div class="c-modal__header">
				<div class="o-grid">
					<div class="o-grid__cell u-no-p">
						<h1 class="c-modal__title c-text c-text--xl" *ngIf="vm.isInitialized">{{ 'Symptom_Check.Rate_Title' | translate }}</h1>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
						<button id="headerCloseButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
							<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
							<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
						</button>
					</div>
				</div>
			</div>
			<div class="c-modal__content" *ngIf="vm.feedback">
				<div class="c-card c-card--height-fit" style="box-shadow:none;">
					<div class="c-form__group" [ngClass]="{'c-form__group--error': vm.submitted && !vm.feedback.rating}">
						<label class="c-form__label c-form__label--light c-form__label--required">{{ 'Symptom_Check.Rate_Rating' | translate }}</label>
						<input-rating [(model)]="vm.feedback.rating" [maxRating]="vm.maxRating" [isRequired]="true"></input-rating>
					</div>
					<div class="c-form__group" [ngClass]="{ 'c-form__group--error': vm.submitted && !vm.feedback.condition }">
						<label for="{{'condition-' + vm.uid}}" class="c-form__label c-form__label--light">{{ 'Symptom_Check.Rate_Condition' | translate }}</label>
						<input-autocomplete id="{{'condition-' + vm.uid}}" name="condition" [(model)]="vm.feedback.condition" [searchFn]="vm.searchConditions" [minLength]="2" [isRequired]="true" [isSmall]="true"></input-autocomplete>
					</div>
					<div class="c-form__group" [ngClass]="{ 'c-form__group--error': vm.submitted && comment.invalid }">
						<label for="{{'comment-' + vm.uid}}" class="c-form__label c-form__label--light">{{ 'Symptom_Check.Rate_Comment' | translate }}</label>
						<textarea rows="6" id="{{'comment-' + vm.uid}}" name="comment" class="c-form__input" [(ngModel)]="vm.feedback.comment" #comment="ngModel" maxlength="{{vm.commentMaxLength}}"></textarea>
						<p class="c-text c-text--sm c-text--right c-text--gray" [ngClass]="{ 'c-text--s3': vm.submitted && comment.invalid }">{{ comment?.value?.length || 0 }} / {{ vm.commentMaxLength }}</p>
					</div>
					<div class="o-grid">
						<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up o-grid__cell--right">
							<button id="closeButton" type="button" class="c-button c-button--s6 c-button--fit" (click)="vm.close()">{{ 'Common.Back' | translate }}</button>
						</div>
						<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up">
							<button id="submitFeedbackButton" type="button" class="c-button c-button--s1 c-button--fit" (click)="vm.submitFeedback(mainForm)">{{ 'Common.Rate' | translate }}</button>
						</div>
					</div>
					<loader-overlay *ngIf="!vm.isInitialized || vm.isProcessing"></loader-overlay>
				</div>
			</div>
		</form>
	</div>
</div>
